import React from 'react'
import ReactDOM from 'react-dom'
import App from './App'

import { Provider } from 'react-redux'
import { applyMiddleware, createStore } from 'redux'
import thunk from 'redux-thunk'
import reducers from './reducers'
import { createLogger } from 'redux-logger'
import ReduxPromise from 'redux-promise'

import ReactGA from 'react-ga'
ReactGA.initialize('UA-88246678-1')
ReactGA.pageview(window.location.pathname + window.location.search)

import { setAlert } from './actions/alerts'

import { extractStrings } from './components/functions'

const errorHandlingMiddleware = store => next => action => {
  if (action.payload && action.payload instanceof Error && action.payload.response) {
    const { status, data } = action.payload.response
    const errorMessage = data.errors ? extractStrings(data.errors) : data.message

    store.dispatch(setAlert(errorMessage || 'Sorry, we were unable to process your request at this time.', undefined, 'error'))
  } else {
    next(action)
  }
}

const logger = createLogger()
const store  = createStore(
  reducers,
  applyMiddleware(thunk, ReduxPromise, errorHandlingMiddleware, logger)
)

ReactDOM.render(
  <Provider store={store}>
    <App />
  </Provider>,
  document.getElementById('root')
)



// WEBPACK FOOTER //
// ./src/index.js